var _a;
import { FiasRoomType } from '../types';
export var houseTypes = {
    None: '',
    Hold: 'владение',
    House: 'дом',
    HouseHold: 'домовладение',
    Garage: 'гараж',
    Building: 'здание',
    Mine: 'шахта',
    Structure: 'строение',
    Construction: 'сооружение',
    Litera: 'литера',
    Housing: 'корпус',
    Basement: 'подвал',
    BoilerRoom: 'котельная',
    Cellar: 'погреб',
    UnfinishedConstruction: 'объект нез-го стр-ва',
};
export var houseAddTypes = {
    None: '',
    Structure: 'строение',
    Construction: 'сооружение',
    Litera: 'литера',
    Housing: 'корпус',
};
export var flatTypes = {
    0: '',
    1: 'помещение',
    2: 'квартира',
    3: 'офис',
    4: 'комната',
    5: 'рабочий участок',
    6: 'склад',
    7: 'торговый зал',
    8: 'цех',
    9: 'павильон',
    10: 'подвал',
    11: 'котельная',
    12: 'погреб',
    13: 'гараж',
    14: 'машино-место',
};
export var roomTypes = (_a = {},
    _a[FiasRoomType.None] = '',
    _a[FiasRoomType.Room] = 'комната',
    _a[FiasRoomType.Placement] = 'помещение',
    _a);
export var estateStatuses = {
    None: '',
    Hold: 'владение',
    House: 'дом',
    HouseHold: 'домовладение',
    Garage: 'гараж',
    Building: 'здание',
    Mine: 'шахта',
    Basement: 'подвал',
    BoilerRoom: 'котельная',
    Cellar: 'погреб',
};
